// @ts-check

import { useCallback, useEffect, useState } from "react"
import { Box, FooterHelp, Frame, InlineStack, Link } from "@shopify/polaris";
import { NavMenu } from '@shopify/app-bridge-react';

import { useRollbarPerson } from "@rollbar/react";
import { usePostHog } from "posthog-js/react";

import { AdminModal } from "components/AdminModal/AdminModal";

import { useShopUrl } from "hooks/use-shop-url";

export const Page = ({ children }) => {
  const shopUrl = useShopUrl();
  const posthog = usePostHog();

  const [adminModalOpen, setAdminModalOpen] = useState(false);

  useRollbarPerson({ shopUrl });

  const handleChatOpened = useCallback(() => {
    posthog.capture("support-chat-opened");
  }, []);

  const handleChatClosed = useCallback(() => {
    posthog.capture("support-chat-closed");
  }, []);

  useEffect(() => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "a0d0cb58-e02d-4727-b4cf-17d53afa12d7";
    const d = document;
    const s = d.createElement("script");
    s.src = "https://client.crisp.chat/l.js";
    s.async = 1;
    d.getElementsByTagName("head")[0].appendChild(s);

    window.$crisp.push(["on", "chat:opened", handleChatOpened]);
    window.$crisp.push(["on", "chat:closed", handleChatClosed]);

    return () => {
      window.$crisp.push(["off", "chat:opened"]);
      window.$crisp.push(["off", "chat:closed"]);
    };
  }, []);

  useEffect(() => {
    if (shopUrl) {
      window.$crisp?.push(["set", "session:data", ["shop", shopUrl]]);
    }
  }, [shopUrl]);

  useEffect(() => {
    if (posthog && shopUrl) {
      posthog.identify(shopUrl);
    }
  }, [posthog, shopUrl]);

  const handleSupportClick = (e) => {
    window.$crisp.push(["do", "chat:open"]);
  };

  return (
    <Frame>
      <NavMenu>
        <a href="/" rel="home">Home</a>
        <a href="/utm-sets">UTM sets</a>
        <a href="/orders">Orders</a>
        <a href="/ad-campaigns">Ad campaigns</a>
        <a href="/utm-generator">Generate UTM link</a>
        <a href="/settings">Settings</a>
      </NavMenu>

      <Box paddingBlockEnd="800">
        {children}

        <AdminModal
          open={adminModalOpen}
          setOpen={setAdminModalOpen}
        />

        <FooterHelp>
          <InlineStack gap="800">
            <Link url="https://www.origintracking.xyz" target="_blank">
              Website
            </Link>
            <Link onClick={handleSupportClick}>
              Request a feature
            </Link>
            <Link url="https://apps.shopify.com/origin-utm-tracking#modal-show=ReviewListingModal" target="_blank">
              Leave a review
            </Link>
            <Link onClick={handleSupportClick}>
              Contact support
            </Link>
          </InlineStack>
        </FooterHelp>
      </Box>
    </Frame>
  );
}
